/* Kenetik shared behaviours — loaded once, deferred, from snippets/kenetik-styles.liquid.
   Vanilla, once-guarded. Everything works without it (content and forms are in HTML).
   Page-only behaviour lives in assets/<prefix>.js. Buy logic is exposed as window.Kenetik.initBuyForm. */
(function () {
  if (window.Kenetik) return;
  var d = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  d.querySelectorAll('.kx').forEach(function (el) { el.classList.add('js'); });
  var motion = d.documentElement.classList.contains('kx-motion');

  /* Motion layer (html.kx-motion): tag section heads, cards and rows below the fold for the scroll reveal, staggered
     80ms within a row (max 3 steps). Never the hero, the buy box, dialogs or anything already on screen at load. */
  if (motion && hasIO && !reduce) {
    var vh = window.innerHeight, seen = [];
    d.querySelectorAll('.home-section-head, .kx-card, .kx-media-card, .home-video-card, .home-science__stat, .home-guarantee .kx-value-prop, .home-final__inner > *, .home-band__inner > *, .about-story__head, .about-belief__head, .about-chapter, .about-arena, .kx-faq__head, .kx-accordion__item, .kx-xsell__item, .kx-steps__step, .rev-quote, .ing-card, .sub-plan, .kx-compare__inner, .mbf-fuel__head, .mbf-challenge__head, .mbf-phase').forEach(function (el) {
      if (el.classList.contains('kx-reveal') || el.closest('.home-hero, .kx-page-hero, .kx-buy, dialog, header, footer, cart-drawer-component, .cart-drawer')) return;
      if (el.getBoundingClientRect().top < vh) return;
      var p = el.parentNode, n = 0;
      for (var i = 0; i < seen.length; i++) if (seen[i] === p) n++;
      seen.push(p);
      el.classList.add('kx-reveal'); if (n) el.dataset.delay = String(Math.min(n, 3));
    });
  }

  /* Science stats count up once when scrolled into view (the member band has its own, in home.js). The final value
     stays in the HTML for crawlers and screen readers; only an aria-hidden copy animates. Ranges are left static. */
  if (motion && hasIO && !reduce) {
    d.querySelectorAll('.home-science__stat dt').forEach(function (dt) {
      var final = dt.textContent.trim(), m = /^([^0-9]*)(\d{1,3}(?:,\d{3})*)([^0-9]*)$/.exec(final);
      if (!m || dt.getBoundingClientRect().top < window.innerHeight) return;
      var pre = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suf = m[3];
      var live = d.createElement('span'), sr = d.createElement('span');
      live.setAttribute('aria-hidden', 'true'); live.textContent = pre + '0' + suf;
      sr.className = 'kx-visually-hidden'; sr.textContent = final;
      dt.textContent = ''; dt.appendChild(live); dt.appendChild(sr);
      var cio = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return; cio.disconnect();
        var t0 = performance.now(), dur = 1400;
        (function tick(now) {
          var q = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - q, 3);
          live.textContent = pre + Math.round(target * e).toLocaleString('en-US') + suf;
          if (q < 1) requestAnimationFrame(tick);
        })(t0);
      }, { threshold: 0.5 });
      cio.observe(dt);
    });
  }

  /* Reveal on scroll (opacity/translate only, base state visible) */
  if (hasIO && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target; t.classList.add('is-visible'); io.unobserve(t);
        if (t.dataset.delay) setTimeout(function () { t.removeAttribute('data-delay'); }, 1000); /* so later hovers don't lag */
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    d.querySelectorAll('.kx-reveal, [data-reveal]').forEach(function (el) { io.observe(el); });
    /* Safety net: anything the observer misses is shown once it has been scrolled into view (checked at most every 250ms; stops when nothing is left). */
    var sweepQueued = false;
    var sweep = function () {
      sweepQueued = false;
      var left = 0, vh2 = window.innerHeight;
      d.querySelectorAll('.kx-reveal:not(.is-visible), [data-reveal]:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh2) { el.classList.add('is-visible'); io.unobserve(el); } else left++;
      });
      if (!left) window.removeEventListener('scroll', onSweep);
    };
    var onSweep = function () { if (!sweepQueued) { sweepQueued = true; setTimeout(sweep, 250); } };
    window.addEventListener('scroll', onSweep, { passive: true });
  } else {
    d.querySelectorAll('.kx-reveal, [data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Pause controls (WCAG 2.2.2): marquees */
  d.querySelectorAll('.kx-marquee__pause').forEach(function (b) {
    var m = b.closest('.kx-marquee');
    b.addEventListener('click', function () { b.setAttribute('aria-pressed', m.classList.toggle('is-paused') ? 'true' : 'false'); });
  });

  /* Rotating phrase: the heading's HTML holds one phrase (what crawlers and screen readers get); the other
     phrases sit in a <template>. Two spans swap text in place, so the live DOM only ever holds the current
     phrase (plus the outgoing one for 400ms, aria-hidden). One phrase per data-interval ms (the section's "Seconds per
     rotating phrase", 2.3 s by default). Never rotates under reduced motion. */
  d.querySelectorAll('.kx-rotator').forEach(function (r) {
    var tpl = r.querySelector('template'), cur = r.querySelector('span'); if (!cur) return;
    var phrases = [cur.textContent];
    if (tpl) { Array.prototype.forEach.call(tpl.content.querySelectorAll('span'), function (sp) { phrases.push(sp.textContent); }); tpl.remove(); }
    var scope = r.closest('[data-rotator-scope]'), btn = scope ? scope.querySelector('.kx-rotator__pause') : null;
    if (phrases.length < 2 || reduce) { if (btn) btn.hidden = true; return; }
    var out = d.createElement('span'); out.setAttribute('aria-hidden', 'true'); r.appendChild(out);
    var i = 0, paused = false;
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () { paused = !paused; btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); });
    }
    setInterval(function () {
      if (paused || d.hidden) return;
      i = (i + 1) % phrases.length;
      out.textContent = cur.textContent; out.className = 'is-active'; void out.offsetWidth; out.className = 'is-leaving';
      cur.classList.remove('is-active'); cur.textContent = phrases[i]; void cur.offsetWidth; cur.classList.add('is-active');
      setTimeout(function () { out.className = ''; out.textContent = ''; }, 400);
    }, Math.max(1000, parseFloat(r.dataset.interval) || 2300));
  });

  /* Product gallery thumbnails → slides */
  d.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelector('[data-gallery-slides]');
    var thumbs = g.querySelectorAll('[data-gallery-thumbs] button');
    if (!slides) return;
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { slides.scrollTo({ left: slides.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' }); });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }, { passive: true });
  });

  /* Carousels. A slide is any child but the quick-buy <dialog> (and <template>) rendered after each product card. */
  function slides(c) { return [].filter.call(c.children, function (el) { return !/^(DIALOG|TEMPLATE|SCRIPT)$/.test(el.tagName); }); }
  /* Distance from the carousel's snap point (centre on phones, padded start edge on desktop) to a slide's own */
  function snapDelta(c, el) {
    var cr = c.getBoundingClientRect(), r = el.getBoundingClientRect();
    if (/center/.test(getComputedStyle(el).scrollSnapAlign)) return r.left + r.width / 2 - (cr.left + c.clientWidth / 2);
    return r.left - (cr.left + (parseFloat(getComputedStyle(c).scrollPaddingLeft) || 0));
  }
  function snapped(c, list) {
    var best = list[0], bd = Infinity;
    list.forEach(function (el) { var dd = Math.abs(snapDelta(c, el)); if (dd < bd) { bd = dd; best = el; } });
    return best;
  }

  /* Endless loop (data-carousel-loop): a copy of the whole set sits on each side. When a scroll settles on a copy it
     jumps, without animation, to the same card in the real set, so past the last card comes the first and back from
     the first comes the last. Copies are inert, hidden from assistive tech and carry no video, video buttons, ids or
     editor hooks, and reveal on scroll like the real cards; the theme editor gets the plain carousel. */
  d.querySelectorAll('[data-carousel-loop]').forEach(function (c) {
    var real = slides(c);
    if (real.length < 2 || (window.Shopify && window.Shopify.designMode) || c.scrollWidth <= c.clientWidth + 2) return;
    real.forEach(function (el, i) {
      el.dataset.slide = i;
      if (el.matches('.kx-card:nth-child(3n + 2)')) el.classList.add('is-raised'); /* the desktop stagger, before the copies shift positions */
    });
    function copy(el) {
      var k = el.cloneNode(true);
      k.setAttribute('data-loop-copy', ''); k.setAttribute('aria-hidden', 'true'); k.inert = true;
      ['id', 'data-shopify-editor-block', 'data-ambient-video', 'data-delay'].forEach(function (a) { k.removeAttribute(a); });
      k.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
      k.querySelectorAll('video, [data-video-toggle], .home-video-card__play').forEach(function (x) { x.remove(); });
      k.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      return k;
    }
    var head = d.createDocumentFragment(), tail = d.createDocumentFragment(), t = 0, touching = false;
    real.forEach(function (el) { head.appendChild(copy(el)); tail.appendChild(copy(el)); });
    c.insertBefore(head, c.firstChild); c.appendChild(tail); c.classList.add('is-looping');
    if (io) c.querySelectorAll('[data-loop-copy].kx-reveal:not(.is-visible)').forEach(function (k) { io.observe(k); });
    function span() { return real[0].offsetLeft - c.firstElementChild.offsetLeft; } /* one full set */
    function jump(px) { c.style.scrollBehavior = 'auto'; c.scrollLeft += px; c.style.scrollBehavior = ''; }
    function settle() {
      if (touching) return;
      var at = snapped(c, slides(c));
      if (at.hasAttribute('data-loop-copy')) jump(at.compareDocumentPosition(real[0]) & Node.DOCUMENT_POSITION_FOLLOWING ? span() : -span());
    }
    function later() { clearTimeout(t); t = setTimeout(settle, 150); }
    jump(span());
    c.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    c.addEventListener('touchend', function () { touching = false; later(); }, { passive: true });
    c.addEventListener('touchcancel', function () { touching = false; later(); }, { passive: true });
    c.addEventListener('scroll', later, { passive: true });
    if ('onscrollend' in window) c.addEventListener('scrollend', settle);
    window.addEventListener('resize', later);
  });

  /* Carousel dots (one per real card): the active one follows the scroll; a click scrolls to that card. They are a
     pointer shortcut: the region itself stays keyboard-scrollable, so the dots stay out of the tab order. */
  d.querySelectorAll('[data-carousel-dots]').forEach(function (wrap) {
    var c = d.querySelector('[data-carousel="' + wrap.dataset.carouselDots + '"]'); if (!c) return;
    var loop = c.classList.contains('is-looping'), real = slides(c).filter(function (el) { return !el.hasAttribute('data-loop-copy'); });
    var n = real.length, dots = [], raf = 0; if (n < 2) return;
    real.forEach(function (el) {
      var dot = d.createElement('button'); dot.type = 'button'; dot.className = 'kx-carousel-dot'; dot.tabIndex = -1;
      dot.addEventListener('click', function () { c.scrollBy({ left: snapDelta(c, el), behavior: reduce ? 'auto' : 'smooth' }); });
      wrap.appendChild(dot); dots.push(dot);
    });
    function sync() {
      raf = 0; var at;
      if (loop) at = +snapped(c, slides(c)).dataset.slide;
      else { var max = c.scrollWidth - c.clientWidth; at = max > 2 ? Math.round(c.scrollLeft / max * (n - 1)) : 0; }
      dots.forEach(function (dt, j) { dt.classList.toggle('is-active', j === at); });
    }
    c.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* Muted ambient videos: play only while mostly in view, never under reduced motion, with a visible pause toggle */
  var ambient = d.querySelectorAll('[data-ambient-video]');
  ambient.forEach(function (card) {
    var v = card.querySelector('video'), t = card.querySelector('[data-video-toggle]');
    if (!v) { if (t) t.hidden = true; return; }
    if (reduce) { if (t) t.hidden = true; return; }
    if (t) t.addEventListener('click', function () {
      var stop = !card.classList.contains('is-user-paused') && !v.paused;
      card.classList.toggle('is-user-paused', stop);
      if (stop) { v.pause(); card.classList.remove('is-playing'); } else { v.play().then(function () { card.classList.add('is-playing'); }).catch(function () {}); }
      t.setAttribute('aria-pressed', stop ? 'true' : 'false');
    });
  });
  if (hasIO && !reduce && ambient.length) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var card = e.target, v = card.querySelector('video'); if (!v) return;
        if (e.intersectionRatio >= 0.85 && !card.classList.contains('is-user-paused')) { v.play().then(function () { card.classList.add('is-playing'); }).catch(function () {}); }
        else { v.pause(); card.classList.remove('is-playing'); }
      });
    }, { threshold: [0, 0.85, 1] });
    ambient.forEach(function (el) { vio.observe(el); });
  }

  /* Video review cards: swap the poster for the real player on demand */
  d.querySelectorAll('[data-video-play]').forEach(function (b) {
    b.addEventListener('click', function () {
      var card = b.closest('.kx-media-card'), tpl = card.querySelector('template'); if (!tpl) return;
      var img = card.querySelector('img'); if (img) img.remove(); b.remove();
      card.prepend(tpl.content.cloneNode(true));
      var v = card.querySelector('video'); if (v) { v.setAttribute('controls', ''); v.play().catch(function () {}); v.focus(); }
    });
  });

  /* Cart add. Goes through Horizon's own cart event (CartLinesUpdateEvent from @shopify/events, via the import
     map) so the drawer, cart page, header count and screen-reader announcement all update the Horizon way: the
     add response carries the re-rendered cart sections and Horizon morphs them in. If the module can't load,
     falls back to re-rendering the drawer section ourselves. */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var announce = (function () {
    var el = null;
    return function (msg) {
      if (!el) { el = d.createElement('p'); el.className = 'kx-visually-hidden'; el.setAttribute('aria-live', 'polite'); el.id = 'kx-live'; d.body.appendChild(el); }
      el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 50);
    };
  })();
  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) { try { eventsModule = import('@shopify/events').catch(function () { return null; }); } catch (e) { eventsModule = Promise.resolve(null); } }
    return eventsModule;
  }
  function cartSectionIds() {
    var ids = [];
    if (d.getElementById('shopify-section-cart-drawer-section')) ids.push('cart-drawer-section');
    d.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId); });
    return ids;
  }
  function openCart() {
    var drawer = d.getElementById('cart-drawer');
    if (drawer && drawer.hasAttribute('open')) return;
    if (window.Shopify && Shopify.actions && Shopify.actions.openCart) return Shopify.actions.openCart();
    if (!drawer) window.location.href = root + 'cart';
  }
  /* A row that was just added drops out of the cross-sell when the drawer re-renders; keep focus somewhere sensible */
  function restoreFocus() {
    var a = d.activeElement;
    if (a && a !== d.body && a.isConnected) return;
    var t = d.getElementById('kx-xsell-title-drawer') || d.querySelector('#cart-drawer .theme-drawer__close-button');
    if (t) t.focus();
  }
  function openCartAfterAdd() {
    var wrap = d.getElementById('shopify-section-cart-drawer-section');
    if (!wrap || !window.fetch) return openCart();
    return fetch(root + '?sections=cart-drawer-section', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) { if (json['cart-drawer-section']) wrap.innerHTML = json['cart-drawer-section']; })
      .catch(function () {})
      .then(openCart);
  }
  function addToCart(form) {
    var fd = new FormData(form), qty = parseInt(fd.get('quantity'), 10) || 1, ids = cartSectionIds();
    if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
    var post = function () {
      return fetch(form.action + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var err = new Error(j.description || j.message || 'add failed'); err.shopify = true; throw err; } return j; }); });
    };
    var getCart = function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); };
    return loadEvents().then(function (ev) {
      if (!ev || !ev.CartLinesUpdateEvent) return post().then(function () { return openCartAfterAdd(); });
      var deferred = ev.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: qty }], promise: deferred.promise }));
      return post().then(function (resp) {
        return getCart().then(function (cart) {
          var dlg = form.closest('dialog'); if (dlg && dlg.open) dlg.close();
          deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'kenetik-buy-form', itemCount: qty, sections: resp.sections, didError: false } });
          return deferred.promise.then(function () { setTimeout(function () { restoreFocus(); openCart(); }, 0); });
        });
      }, function (err) {
        getCart().then(function (cart) { deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'kenetik-buy-form', didError: true } }); }, deferred.reject);
        throw err;
      });
    });
  }

  /* Shared buy logic: buy box + quick-buy dialogs. Resolves the variant from option inputs, keeps sizes
     in step with the flavor (availability + Hidden / Sold out rules), prices subscribe/one-time, quantity, ajax add. */
  function initBuyForm(form, opts) {
    if (form.dataset.kxBound) return; form.dataset.kxBound = '1';
    var variants = []; try { variants = JSON.parse(form.dataset.variants); } catch (e) {}
    if (!variants.length) return;
    var planId = form.dataset.planId, planPct = parseFloat(form.dataset.planPercent) || 0, fmt = form.dataset.moneyFormat || '${{amount}}';
    var money = function (cents) { var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/<[^>]+>/g, ''); };
    var q = function (sel) { return form.querySelector(sel); };
    var live = q('[data-live]'), atc = q('[data-atc]') || q('button[type="submit"]');
    var sizeNum = function (s) { return parseInt(String(s || '').replace(/[^0-9]/g, ''), 10) || 0; };
    /* Options are read by position (resolved by name in Liquid); -1 = the product has no such option.
       Forms without the attributes (quick-buy) keep the Flavor = option 1, Size = option 2 convention. */
    var idx = function (name, dflt) { var n = parseInt(form.dataset[name], 10); return isNaN(n) ? dflt : n; };
    var fi = idx('flavorIndex', 0), si = idx('sizeIndex', 1);
    var fOf = function (v) { return fi >= 0 && v.options ? v.options[fi] : (fi === 0 ? v.option1 : null); };
    var sOf = function (v) { return si >= 0 && v.options ? v.options[si] : (si === 1 ? v.option2 : null); };
    /* Variant ids from snippets/kenetik-variant-rules (Theme settings > Kenetik flavors + the hidden-variants metafield):
       hidden = never offered; sold out = its size tile stays visible, greyed and disabled. */
    var hiddenIds = (form.dataset.hiddenVariants || '').split(',').filter(Boolean);
    var soldIds = (form.dataset.soldoutVariants || '').split(',').filter(Boolean);
    var isHidden = function (v) { return hiddenIds.indexOf(String(v.id)) !== -1; };
    var isSold = function (v) { return soldIds.indexOf(String(v.id)) !== -1; };
    /* Ships later = can be bought, labelled "Ships 11/16" (Theme settings > Kenetik flavors > Pre-order) */
    var preIds = (form.dataset.preorderVariants || '').split(',').filter(Boolean);
    var isPre = function (v) { return v.available && preIds.indexOf(String(v.id)) !== -1; };
    var unit = form.dataset.unitLabel || 'can';
    /* Units per variant — same rule as the Liquid: a number in parentheses wins ("3-Pack (12 servings)" → 12),
       else the leading number ("6-Pack" → 6), else 1. */
    var unitsOf = function (val) { var t = String(val || ''), m = /\((\d+)/.exec(t) || /^\s*(\d+)/.exec(t); return m ? parseInt(m[1], 10) : 1; };
    var packUnits = parseInt(form.dataset.packUnits, 10) || 1; /* products with no size option (bundles) */
    var packOf = function (v) { return si >= 0 ? unitsOf(sOf(v)) : packUnits; };
    /* Subscription price: this plan's allocation, else the plan's % policy (some allocations aren't exposed), else full price. */
    var subOf = function (v) {
      var alloc = (v.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === String(planId); });
      return alloc ? alloc.price : (planPct ? Math.round(v.price * (100 - planPct) / 100) : v.price);
    };
    var flavor = function () { var i = q('input[name="option-flavor"]:checked'); return i ? i.value : null; };
    var size = function () { var i = q('input[name="option-size"]:checked'); return i ? i.value : null; };
    function current() { var f = flavor(), sz = size(); return variants.find(function (v) { return (fi < 0 || !f || fOf(v) === f) && (si < 0 || !sz || sOf(v) === sz); }) || null; }
    function offered(f) { return variants.filter(function (v) { return (fi < 0 || !f || fOf(v) === f) && v.available && !isHidden(v) && !isSold(v); }); }
    /* Sold-out sizes of flavor f (every size of the product when it has no flavor option): shown, not left out. */
    function soldSizes(f) { return fi >= 0 && !f ? [] : variants.filter(function (v) { return (fi < 0 || fOf(v) === f) && isSold(v); }).map(sOf); }
    /* Size kept across flavor changes: the shopper's last pick, else the size the form opened on (the default
       variant's, e.g. 12 Pack). A size forced by a flavor that has only one (Original Variety → 6 Pack) doesn't stick. */
    var wantSize = null;
    function syncSizes(userChangedFlavor) {
      var f = flavor(); var tiles = form.querySelectorAll('[data-size-tile]'); if (!tiles.length) return;
      var mode = form.dataset.sizeUnavailable || 'hide', firstOk = null, keep = null;
      var avail = offered(f).map(sOf), sold = soldSizes(f);
      tiles.forEach(function (t) {
        var inp = t.querySelector('input'), ok = avail.indexOf(inp.value) !== -1, so = !ok && sold.indexOf(inp.value) !== -1;
        t.hidden = mode === 'hide' && !ok && !so; inp.disabled = !ok; t.classList.toggle('is-unavailable', !ok); t.classList.toggle('is-soldout', so);
        if (ok && (!firstOk || sizeNum(inp.value) < sizeNum(firstOk.value))) firstOk = inp;
        if (ok && inp.value === wantSize) keep = inp;
      });
      var checked = q('input[name="option-size"]:checked');
      if (userChangedFlavor && keep) keep.checked = true;
      else if (firstOk && (userChangedFlavor || !checked || checked.disabled)) firstOk.checked = true;
    }
    /* A flavor whose image the gallery doesn't hold (the homepage shows 5 of the product's images) takes over the first
       slide and its thumbnail (snippets/kenetik-buy-gallery opens on the pre-selected flavor's image). */
    function leadSlide(m, name) {
      var fig = opts.gallery.querySelector('figure'), img = fig && fig.querySelector('img'), src = m.preview_image && m.preview_image.src;
      if (!img || !src) return null;
      var at = function (w) { return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; };
      img.srcset = at(780) + ' 780w, ' + at(1379) + ' 1379w'; img.src = at(1379); img.alt = m.alt || name || ''; img.style.objectPosition = '';
      fig.setAttribute('data-media-id', m.id);
      var gal = opts.gallery.closest('[data-gallery]'), thumb = gal && gal.querySelector('[data-gallery-thumbs] img');
      if (thumb) { thumb.srcset = at(160) + ' 160w'; thumb.src = at(160); thumb.style.objectPosition = ''; }
      return fig;
    }
    var lastId = null, lastFlavor = null;
    function update() {
      var v = current(); if (!v) { if (atc) atc.disabled = true; return; }
      var plan = q('input[name="purchase_type"]:checked'), sub = !!(plan && plan.value === 'subscribe');
      var subPrice = subOf(v), oneP = v.price, qty = packOf(v);
      var pct = oneP > 0 ? Math.round((oneP - subPrice) / oneP * 100) : 0;
      var set = function (sel, txt) { form.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; }); };
      set('[data-sub-price]', money(subPrice)); set('[data-sub-per]', money(Math.round(subPrice / qty)) + '/' + unit); set('[data-save-pct]', 'Save ' + pct + '%');
      set('[data-one-price]', money(oneP)); set('[data-one-per]', money(Math.round(oneP / qty)) + '/' + unit);
      /* "From" = lowest per-can price among the sizes offered for this flavor (subscription when a plan exists) */
      var pool = offered(fOf(v)); if (!pool.length) pool = [v];
      var minPer = Math.min.apply(null, pool.map(function (x) { return Math.round((planId ? subOf(x) : x.price) / packOf(x)); }));
      set('[data-from-price]', 'From ' + money(minPer) + ' per ' + unit);
      form.querySelectorAll('[data-was-price]').forEach(function (n) { n.innerHTML = '<span class="kx-visually-hidden">Regular price </span>' + money(oneP); });
      var qtyEl = q('[data-qty]'), n = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      var price = (sub ? subPrice : oneP) * n;
      set('[data-atc-price]', money(price));
      /* Sweepstakes entries (snippets/kenetik-sweeps): up to N per $1 of the button price */
      var sw = q('[data-sweeps]'); if (sw) set('[data-sweeps-count]', Math.floor(price * (parseInt(sw.dataset.perDollar, 10) || 0) / 100).toLocaleString('en-US'));
      q('[data-variant-id]').value = v.id;
      var sp = q('[data-selling-plan]'); if (sp) { sp.disabled = !sub; sp.value = planId; }
      /* Ships later: the "Ships 11/16" note shows and a one-time line carries the "Ships: 11/16" property (subscribe lines
         don't: Recharge would copy it onto every renewal). The button stays "Add to cart". */
      var pre = isPre(v), note = q('[data-preorder-note]'), prop = q('[data-preorder-prop]');
      if (note) note.hidden = !pre;
      if (prop) prop.disabled = !(pre && !sub);
      var label = v.available ? (atc && atc.dataset.addLabel) || 'Add to cart' : 'Sold out';
      if (atc) { atc.disabled = !v.available; set('[data-atc-label]', label); }
      if (opts && opts.sticky) {
        opts.sticky.querySelector('[data-sticky-price]').textContent = money(price); opts.sticky.querySelector('[data-sticky-sel]').textContent = [plan && plan.dataset.label, sOf(v), fOf(v)].filter(Boolean).join(' · ');
        var sl = opts.sticky.querySelector('[data-sticky-label]'); if (sl && v.available) sl.textContent = label;
      }
      if (live) live.textContent = [fOf(v), sOf(v)].filter(Boolean).join(', ') + ', ' + (sub ? 'subscription ' : 'one-time ') + money(price) + (v.available ? '' : ', sold out') + (pre && note ? ', ' + note.textContent : '');
      /* Product page: keep ?variant= shareable; bring the variant's image into view when the flavor changes */
      if (form.hasAttribute('data-update-url') && lastId !== null && lastId !== v.id && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString());
      }
      if (lastFlavor !== null && lastFlavor !== fOf(v) && opts && opts.gallery && v.featured_media) {
        var fig = opts.gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]') || leadSlide(v.featured_media, fOf(v));
        if (fig) opts.gallery.scrollTo({ left: fig.getBoundingClientRect().left - opts.gallery.getBoundingClientRect().left + opts.gallery.scrollLeft, behavior: reduce ? 'auto' : 'smooth' }); /* horizontal only — never moves the page */
      }
      lastId = v.id; lastFlavor = fOf(v);
    }
    if (atc && !atc.dataset.addLabel) { var lbl = q('[data-atc-label]'); atc.dataset.addLabel = lbl ? lbl.textContent : 'Add to cart'; }
    form.addEventListener('change', function (e) {
      if (e.target.name === 'option-flavor') syncSizes(true); else if (e.target.name === 'option-size') wantSize = e.target.value;
      update();
    });
    form.addEventListener('input', function (e) { if (e.target.matches('[data-qty]')) update(); });
    syncSizes(false); wantSize = size(); update();
    var qtyIn = q('[data-qty]');
    if (qtyIn) {
      var stepQty = function (dlt) { var v = Math.min(parseInt(qtyIn.max, 10) || 99, Math.max(parseInt(qtyIn.min, 10) || 1, (parseInt(qtyIn.value, 10) || 1) + dlt)); qtyIn.value = v; update(); if (live) live.textContent = 'Quantity ' + v; };
      q('[data-qty-dec]').addEventListener('click', function () { stepQty(-1); });
      q('[data-qty-inc]').addEventListener('click', function () { stepQty(1); });
    }
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; e.preventDefault();
      atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true');
      addToCart(form)
        .then(function () { announce('Added to cart.'); })
        .catch(function (err) { var msg = err && err.shopify ? err.message : 'Could not add to cart. Please try again.'; if (live) live.textContent = msg; announce(msg); })
        .then(function () { atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy'); });
    });
  }

  /* Buy box (+ sticky add-to-cart bar) and quick-buy dialogs */
  d.querySelectorAll('[data-buy-box]').forEach(function (box) {
    var form = box.querySelector('[data-buy-form]'); if (!form) return;
    var sticky = box.querySelector('[data-sticky-atc]'), mainAtc = form.querySelector('[data-atc]');
    initBuyForm(form, { sticky: sticky, gallery: box.querySelector('[data-gallery-slides]') });
    if (sticky && mainAtc && hasIO) {
      new IntersectionObserver(function (entries) {
        var e = entries[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 }).observe(mainAtc);
      sticky.querySelector('button').addEventListener('click', function () { mainAtc.focus(); mainAtc.click(); });
    }
  });
  /* Dialogs (nutrition image, quick-buy): native <dialog>, delegated so dialogs inside re-rendered markup (the cart
     drawer's cross-sell) work too. A quick-buy form is wired on first open. Focus returns to the opener. */
  var openers = new WeakMap();
  d.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t.closest && t.closest('[data-dialog-open]');
    if (btn) {
      var dlg = d.getElementById(btn.dataset.dialogOpen); if (!dlg || !dlg.showModal) return;
      var qb = dlg.querySelector('.kx-quickbuy'); if (qb) initBuyForm(qb, {});
      openers.set(dlg, btn); dlg.showModal();
      var first = dlg.querySelector('input:checked, input:not([type="hidden"]), button:not([data-dialog-close])'); if (first) first.focus();
      return;
    }
    var closer = t.closest && t.closest('[data-dialog-close]');
    if (closer) { closer.closest('dialog').close(); return; }
    if (t.matches && t.matches('dialog.kx-dialog')) t.close(); /* backdrop click */
  });
  d.addEventListener('close', function (e) { var b = openers.get(e.target); if (b && b.isConnected) b.focus(); }, true);
  /* Escape closes only the top quick-buy sheet, not the cart drawer underneath it (Horizon's drawer listens on document) */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || e.isComposing) return;
    var open = d.querySelectorAll('dialog.kx-dialog[open]'); if (!open.length) return;
    e.preventDefault(); open[open.length - 1].close();
  }, true);

  window.Kenetik = { initBuyForm: initBuyForm, addToCart: addToCart, openCartAfterAdd: openCartAfterAdd, reduceMotion: reduce };
})();
